import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { checkConsistencyCheckRanTemplateAvailable } from '@api/consistencyCheck';

import { IConsistencyCheckRanCheckTemplates } from '@interfaces/cmModule/consistencyCheck';
import { IConsistencyCheckBatchDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';

import { EUserRoles } from '@enums/common';

import { CONSISTENCY_RAN_ASSIGN_MANY_TEMPLATE } from '@constants/queryKeys';

interface IUseMutateConsistencyCheckRanCheckTemplates {
	count?: number;
	countMismatch?: number;
	isLoadingCheckAvailableTemplate: boolean;
	networkElementNames?: string[];
	checkAvailableTemplate: UseMutateFunction<any, any, IConsistencyCheckBatchDTO, any>;
}

export const useMutateConsistencyCheckRanCheckTemplates = (): IUseMutateConsistencyCheckRanCheckTemplates => {
	const {
		data,
		mutate,
		isLoading,
	} = useMutation<IConsistencyCheckBatchDTO, IConsistencyCheckRanCheckTemplates>({
		mutationKey: [CONSISTENCY_RAN_ASSIGN_MANY_TEMPLATE],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		mutationFn: checkConsistencyCheckRanTemplateAvailable,
	});

	const {
		count,
		countMismatch,
		networkElementNames,
	} = data || {};

	return {
		count,
		countMismatch,
		networkElementNames,
		isLoadingCheckAvailableTemplate: isLoading,
		checkAvailableTemplate: mutate,
	};
};
